import { FC, useEffect } from 'react';
import styles from './EnergyDiagram.module.scss';
interface Props {
  energyLevel: number;
  co2Emission: number;
}

export const EnergyDiagram: FC<Props> = ({ energyLevel, co2Emission }) => {
  const markerNumbers = [25, 50, 75, 100, 125, 150, 175, 200, 225, 250];
  let energyLevelStyle = {};
  let co2EmissionStyle = {};
  useEffect(() => {
    const co2EmissionTextElement = document.querySelector('.co2-emission-text') as HTMLElement;
    const co2EmissionNumberElement = document.querySelector('.co2-emission-number') as HTMLElement;
    const co2EmissionTextWidth = co2EmissionTextElement?.clientWidth;
    const co2EmissionNumberWidth = co2EmissionNumberElement?.clientWidth;
    if (co2Emission * 1.2 + co2EmissionNumberWidth / 2 + 5 + co2EmissionTextWidth > 327) {
      co2EmissionStyle = { justifyContent: 'end' };
    } else {
      co2EmissionStyle = {
        paddingLeft: co2Emission * 1.2 - co2EmissionNumberWidth / 2 + 'px',
      };
    }

    const energyLevelTextElement = document.querySelector('.energy-level-text') as HTMLElement;
    const energyLevelNumberElement = document.querySelector('.energy-level-number') as HTMLElement;
    const energyLevelTextWidth = energyLevelTextElement.clientWidth;
    const energyLevelNumberWidth = energyLevelNumberElement.clientWidth;
    if (energyLevel * 1.2 + energyLevelNumberWidth / 2 + 5 + energyLevelTextWidth > 327) {
      energyLevelStyle = { justifyContent: 'end' };
    } else {
      energyLevelStyle = {
        paddingLeft: energyLevel * 1.2 - energyLevelNumberWidth / 2 + 'px',
      };
    }
  });

  return (
    <>
      <div className={styles['diagram-wrapper']} id="diagram">
        <div className={styles['energy-level']} style={energyLevelStyle}>
          <span className={styles['energy-level-number'] + ' energy-level-number'}>{energyLevel}</span>
          <span className={styles['energy-level-text'] + ' energy-level-text'}>kWh / (m² a) Energiebedarf</span>
        </div>
        <div className={styles.diagram}>
          <div className={styles['diagram-marker-bar']}>
            <div className={styles['energy-marker']} style={{ left: energyLevel * 1.2 + 'px' }}></div>
            <div className={styles['co2-marker']} style={{ left: co2Emission * 1.2 + 'px' }}></div>
            <span className={styles['diagram-marker-number']} style={{ left: '15px' }}>
              -
            </span>
            <span className={styles['diagram-marker-letter']} style={{ left: '15px' }}>
              A+
            </span>
            {markerNumbers.map((number, index) => {
              return (
                <div key={index}>
                  <span className={styles['diagram-marker-letter']} style={{ left: number * 1.2 + 15 + 'px' }}>
                    {String.fromCharCode(65 + index)}
                  </span>
                  <span className={styles['diagram-marker-number']} style={{ left: number * 1.2 + 'px' }}>
                    {number}
                  </span>
                </div>
              );
            })}
            <span className={styles['diagram-marker-number']} style={{ right: 0 }}>
              +
            </span>
          </div>
        </div>
        <div className={styles['co2-emission']} style={co2EmissionStyle}>
          <div className={styles['co2-emission-number'] + ' co2-emission-number'}>
            {/* {{ $n(co2Emission, "decimal", "de") }} */} {co2Emission}
          </div>
          <span className={styles['co2-emission-text'] + ' co2-emission-text'}>kg / (m² a) CO2-Emissionen</span>
        </div>
      </div>
    </>
  );
};
